import React from "react";
import Modal from "react-responsive-modal";
import Button from "../../common/button/Button";
import WComponent from "../../common/WComponent";
import TextFieldInput from "../../common/text_field_input/TextFieldInput";
import BudgetInput from "../../common/budget_input/BudgetInput";

import EngagementService from "../../../services/EngagementService";

import UtilityService from "../../../services/UtilityService";
import RequiredLabel from "../../common/required_label";

const { alert } = UtilityService;

export class BudgetModal extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			// state
			loading: false,
			resource: "",
			budget: "",
			actual: "",
			result: ""
		};
	}

	onSubmit = async () => {
		let { view } = this.props;
		let { onCreate } = this;

		if (view === "create") {
			await onCreate();
		}
	};

	isEmpty = () => {
		let { resource, budget } = this.state;
		return !(resource.length > 0 || budget.length > 0);
	};

	// New method to validate inputs
	validateInputs = () => {
		let { budget } = this.state;
		const missing = this.getMissingRequiredFields();
		let errorMessages = []; // Array to collect error messages

		if (missing.length) {
			errorMessages.push(`Please fill: ${missing.join(", ")}`);
		}


		// Validate budget input using validateBudgetFormat
		if (budget?.trim() && !UtilityService.validateBudgetFormat(budget)) {
			errorMessages.push("Please enter time in the format: 1h 30m or 1h or 30m");
		}

		return errorMessages; // Return collected error messages
	};

	clearModal = () => {
		let { update } = this;

		update({
			resource: "",
			budget: ""
		});
	};

	onClose = () => {
		const { clearModal } = this;
		const { onClose } = this.props;
		clearModal();
		onClose(true);
	};

	onCreate = async () => {
		await this.update({
			loading: true
		});

		let { resource, budget } = this.state;
		let { engagementId } = this.props;
		const { onClose } = this;
		const { validateInputs } = this;
		let created = false;

		let errorMessages = validateInputs();

		if (errorMessages.length > 0) {
			alert({ type: "error", text: errorMessages.join(" ") }); // Updated to use new alert method
			return created;
		}

		try {
			const sanitizedBudget = budget.trim().toString();
			await EngagementService.createBudget({ engagementId, resource, budget: sanitizedBudget });

			created = true;

			await this.update({
				loading: false
			});

			onClose();
		} catch (error) {
			console.log(error);

			alert({ type: "error", text: "Create error!" }); // Updated to use new alert method
			created = false;
		}

		await this.update({
			loading: false
		});
	};

	// Define updateModal as a method
	updateModal() {}

	onChange = e => {
		let target = e.target;
		const { update } = this;

		update({
			[target.name]: target.value
		});
	};

	getMissingRequiredFields = () => {
		const { resource, budget } = this.state;
		const missing = [];
		if (!resource?.trim()) missing.push("Resource");
		if (!budget?.trim()) missing.push("Budget");
		return missing;
	};

	render() {
		let { resource, budget } = this.state;
		const { onChange, onSubmit } = this;

		const { show, onClose } = this.props;

		return (
			<Modal open={show} onClose={onClose} center>
				<div className="modal-title">Create Budget</div>

				<div className="modal-content">
					<TextFieldInput title={<RequiredLabel text="Resource" />} placeholder="e.g., Bookeeping" name="resource" onChange={onChange} value={resource} autoComplete="off" className="ft-budget-resource-input" />
					<BudgetInput name="budget" value={budget} onChange={onChange} />
				</div>

				<div className="modal-footer">
					<Button text="Cancel" onClick={() => onClose(true)} view="secondary" className="ft-budget-cancel-btn" />
					<Button text="Create" onClick={onSubmit} className="ft-budget-create-btn"/>
				</div>
			</Modal>
		);
	}
}
